export const FormColumnWidth = {
  FULL: "full",
  HALF: "half",
} as const;

export type FormColumnWidthValue =
  (typeof FormColumnWidth)[keyof typeof FormColumnWidth];
